<template>
  <div class="home-skeleton">
    <div class="item" v-for="i in 9" :key="i" :style="{ backgroundColor: bg }">
      <div class="left">
        <shSkeleton bg="#e4e4e4" width="250px" height="25px" animated />
        <shSkeleton bg="#e4e4e4" width="250px" height="80px" animated />
      </div>
      <shSkeleton
        bg="#e4e4e4"
        width="130px"
        height="130px"
        margin-right="5px"
        animated
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSkeleton",
  props: {
    bg: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style scoped lang="less">
.home-skeleton {
  width: 1220px;
  height: 480px;
  margin-top: 5px;
  display: flex;
  flex-wrap: wrap;

  justify-content: space-between;

  .item {
    width: 400px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    //margin-bottom: 8px;
    .sh-skeleton ~ .sh-skeleton {
      display: block;
      margin: 8px auto 5px;
    }
  }
}
</style>
